<script>
    import {createEventDispatcher} from "svelte";
    import Editor from "@tinymce/tinymce-svelte";
    import {getEntities, getSchema} from "../../../api-client";
    import {push} from "svelte-spa-router";
    import Select from "svelte-select";
    import TranslationSelect from "./TranslationSelect.svelte";
    import TextInput from "./inputs/TextInput.svelte";
    import ColorInput from "./inputs/ColorInput.svelte";

    export let formField;
    export let fieldLabel;
    export let value;
    export let required;
    export let translatable;

    // optional
    export let name;
    export let selectionSchema;

    $: selectionEntities = [];

    const conf = {
        height: 600,
        plugins: "lists code",
        toolbar:
            "undo redo | numlist bullist | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | code",
    };

    $: editLocale = "de";

    const dispatch = createEventDispatcher();

    function dispatchValueChange(value) {
        dispatch("change", value.detail);
    }

    $: if (formField === "Htmlfield") {
        if (translatable) {
            if (!value) {
                value = {de: "", en: "", fr: ""};
            } else if (typeof value === "string") {
                value = {de: value, en: "", fr: ""};
            } else {
                if (!value["de"]) {
                    value["de"] = "";
                }
                if (!value["en"]) {
                    value["en"] = "";
                }
                if (!value["fr"]) {
                    value["fr"] = "";
                }
            }
        } else {
            if (!value) {
                value = "";
            }
        }
    } else if (formField === "Anyfield") {
        if (translatable && name === "sections") {
            if (!value) {
                value = {de: [], en: [], fr: []};
            } else if (typeof value == "array") {
                value = {de: value, en: [], fr: []};
            } else {
                if (!value["de"]) {
                    value["de"] = [];
                }
                if (!value["en"]) {
                    value["en"] = [];
                }
                if (!value["fr"]) {
                    value["fr"] = [];
                }
            }
        } else {
            if (!value) {
                value = [];
            }
        }
    }

    $: isTranslationMissingForSection =
        formField == "Anyfield" &&
        name == "sections" &&
        (value["de"].length == 0 ||
            value["en"].length == 0 ||
            value["fr"].length == 0);

    $: translationNeeded = required
        ? !value ||
        !value["de"] ||
        !value["en"] ||
        !value["fr"] ||
        isTranslationMissingForSection
        : false;

    if (formField === "Selection") {
        getEntities(selectionSchema).then((entities) => {
            selectionEntities = entities;
        });
        if (!value) {
            value = {id: 0, name: "Leer"};
        }
    } else if (formField === "MultiSelection") {
        getEntities(selectionSchema).then((entities) => {
            selectionEntities = entities;
        });
        if (!value) {
            value = [];
        }
    }

    //$: value;

    console.log(formField + " " + JSON.stringify(value));

    $: htmlValue = "";
    setTimeout(() => {
        if (formField !== "Htmlfield") return;
        if (translatable) {
            htmlValue = value[editLocale];
        } else {
            htmlValue = value;
        }
    }, 1000);

    function moveMultiSelectionElementUp(index) {
        const elementCount = value.length;
        if (index > 0) {
            [value[index - 1], value[index]] = [value[index], value[index - 1]];
        }
    }

    function moveMultiSelectionElementDown(index) {
        const elementCount = value.length;
        if (index < elementCount - 1) {
            [value[index + 1], value[index]] = [value[index], value[index + 1]];
        }
    }
</script>

{#if formField === "Colorpicker"}
    <ColorInput {value} on:change={dispatchValueChange} label={fieldLabel}/>
{:else if formField === "Textfield"}
    <TextInput
            {value}
            {translatable}
            label={fieldLabel}
            {required}
            on:change={dispatchValueChange}
    />
{:else if formField === "Datefield"}
    <div class="form-field-wrapper">
        <label class="form-field-label">{fieldLabel}</label>
        <input
                class="input-style"
                type="datetime-local"
                {value}
                on:input={(val) => dispatch("change", val.target.value)}
        />
        {#if required && (!value || value.length == 0)}
            <label class="form-field-label error-label"
            >Dieses Feld ist erforderlich</label
            >
        {/if}
    </div>
{:else if formField === "Htmlfield"}
    <div style="width: 526px;">
        <div class="section-title-row">
            <label class="form-field-label">{fieldLabel}</label>
            {#if translatable}
                <TranslationSelect
                        {translationNeeded}
                        bind:editLocale
                        on:select={() => {
                        translatable = false;
                        setTimeout(() => {
                            htmlValue = value[editLocale];
                            translatable = true;
                        }, 100);
                    }}
                />
            {/if}
        </div>
        {#if translatable}
            <Editor
                    api-key="iq6iq1t93pfrz9ua639vso6gdyn2r0wtxx87q4as3kgap1x4"
                    channel="5"
                    {conf}
                    bind:value={htmlValue}
                    on:change={(val) => {
                    setTimeout(() => {
                        value[editLocale] = htmlValue;
                    console.log(value)
                    dispatch("change", value)
                        }, 100);;
                }}
            />
        {:else}
            <Editor
                    api-key="iq6iq1t93pfrz9ua639vso6gdyn2r0wtxx87q4as3kgap1x4"
                    channel="5"
                    {conf}
                    bind:value={htmlValue}
                    on:change={(val) => {
                    dispatch("change", htmlValue);
                }}
            />
        {/if}
        {#if required && (!value || value.length == 0)}
            <label class="form-field-label error-label"
            >Dieses Feld ist erforderlich</label
            >
        {/if}
    </div>
{:else if formField === "Checkbox"}
    <div style="display: flex; flex-direction: row; align-items: center">
        <label class="form-field-label">{fieldLabel}</label>
        <input
                type="checkbox"
                style="margin:0; width: 24px; height: 24px; margin-left: 8px"
                checked={value}
                on:change={(val) => dispatch("change", val.target.checked)}
        />
    </div>
{:else if formField === "Selection"}
    <div class="form-field-wrapper">
        <label class="form-field-label">{fieldLabel}</label>
        <div class="section-title-row">
            {#await getSchema(selectionSchema) then schema}
                <select
                        bind:value
                        on:change={() => dispatch("change", value)}
                        class="selector"
                >
                    {#await selectionEntities then entities}
                        {#each [{
                            id: null,
                            name: "Keine Auswahl",
                            title: "Keine Auswahl"
                        }, ...(entities ?? [])] as entity}
                            <option
                                    value={entity.id}
                                    selected={entity.id === value}
                            >
                                {entity[schema.nameProperty]}
                            </option>
                        {/each}
                    {/await}
                </select>
            {/await}

            {#if value}
                <img
                        src="/images/icons/open_in_tab.svg"
                        alt="Auswahl öffnen"
                        on:click={() =>
                        push(`/admin/entities/${selectionSchema}/${value}`)}
                        class="open-in-new"
                />
            {/if}
        </div>
        {#if required && (!value || value.length == 0)}
            <label class="form-field-label error-label"
            >Dieses Feld ist erforderlich</label
            >
        {/if}
    </div>
{:else if formField === "MultiSelection" && name === "fk_tags"}
    <div class="form-field-wrapper">
        <label class="form-field-label">{fieldLabel}</label>
        {#await getEntities("tag") then tags}
            <Select
                    items={tags}
                    value={tags.filter((tag) => (value ?? []).includes(tag.id))}
                    on:select={(event) => {
                    dispatch("change", event.detail?.map((e) => e.id) ?? []);
                }}
                    isMulti={true}
                    optionIdentifier="id"
                    labelIdentifier="name"
                    containerClasses="selector"
            />
        {/await}
    </div>
{:else if formField === "MultiSelection"}
    <div class="form-field-wrapper">
        <div class="section-title-row">
            <label class="form-field-label">{fieldLabel}</label>
            <img
                    src="/images/icons/plus.svg"
                    alt="Element hinzufügen"
                    on:click={() => {
                    value = [
                        ...(value ?? []),
                        {
                            id: null,
                            name: "Keine Auswahl",
                            title: "Keine Auswahl",
                        },
                    ];
                }}
            />
        </div>
        {#if !value || value.length === 0}
            <div class="text-l">Keine</div>
        {:else}
            {#await getSchema(selectionSchema) then schema}
                <div>
                    {#each value ?? [] as selection, index}
                        <div class="section-title-row">
                            <div
                                    style="display: flex; flex-direction:column; justify-content:space-between; padding: 4px"
                            >
                                {#if index > 0}
                                    <svg
                                            on:click={() => {
                                            moveMultiSelectionElementUp(index);
                                        }}
                                            width="23"
                                            height="23"
                                            viewBox="0 0 23 23"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                                d="M11 22L11 2M11 2L19 10.3333M11 2L3 10.3333"
                                                stroke="#1A1A17"
                                        />
                                    </svg>
                                {:else}
                                    <div style="width: 23px; height:23px"/>
                                {/if}
                                {#if index < value.length - 1}
                                    <svg
                                            on:click={() => {
                                            moveMultiSelectionElementDown(
                                                index
                                            );
                                        }}
                                            width="23"
                                            height="23"
                                            viewBox="0 0 23 23"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                                d="M12 0.999999L12 21M12 21L4 12.6667M12 21L20 12.6667"
                                                stroke="#1A1A17"
                                        />
                                    </svg>
                                {:else}
                                    <div style="width: 23px; height:23px"/>
                                {/if}
                            </div>
                            <select
                                    bind:value={selection}
                                    on:change={() => dispatch("change", value)}
                                    class="selector"
                            >
                                {#await selectionEntities then entities}
                                    {#each entities as entity}
                                        <option
                                                value={entity.id}
                                                selected={entity.id === value}
                                        >
                                            {entity[schema.nameProperty]}
                                        </option>
                                    {/each}
                                {/await}
                            </select>

                            <img
                                    src="/images/icons/minus.svg"
                                    alt="Auswahl löschen"
                                    on:click={() => {
                                    value = value.filter((_, i) => i !== index);
                                    dispatch("change", value);
                                }}
                                    class="open-in-new"
                            />
                            <img
                                    src="/images/icons/open_in_tab.svg"
                                    alt="Auswahl öffnen"
                                    on:click={() =>
                                    push(
                                        `/admin/entities/${selectionSchema}/${selection}`
                                    )}
                                    class="open-in-new"
                            />
                        </div>
                    {/each}
                </div>
            {/await}
        {/if}

        {#if required && (!value || value.length == 0)}
            <label class="form-field-label error-label"
            >Dieses Feld ist erforderlich</label
            >
        {/if}
    </div>
{:else if formField === "Anyfield" && name == "sections"}
    <div class="form-field-wrapper">
        <div class="section-title-row">
            <label class="form-field-label">{fieldLabel}</label>
            {#if translatable}
                <TranslationSelect
                        {translationNeeded}
                        bind:editLocale
                        on:select={() => {
                        console.log("select", value[editLocale]);
                        translatable = false;
                        setTimeout(() => {
                            translatable = true;
                        }, 100);
                    }}
                />
            {/if}
        </div>
        {#each translatable ? value[editLocale] : value.de ?? value ?? [] as section, index}
            {#if section.type == "html"}
                <div class="section-title-row">
                    <div style="height: 32px;"/>
                    <img
                            src="/images/icons/minus.svg"
                            on:click={() => {
                            console.log(section);
                            value = value.filter((sec) => sec !== section);
                            dispatch("change", value);
                        }}
                            alt="Textabschnitt entfernen"
                    />
                </div>
                <label class="form-field-label">Unterüberschrift</label>
                <input
                        class="input-style"
                        type="text"
                        value={section.header}
                        on:input={(val) => {
                        section.header = val.target.value;
                        dispatch("change", value);
                    }}
                />
                <Editor
                        bind:value={section.content}
                        on:change={(val) => {
                        //section.content = val.target.value;
                        dispatch("change", value);
                    }}
                />
            {:else if section.type == "images"}
                <div class="section-title-row">
                    <div style="height: 32px;"/>
                    <img
                            src="/images/icons/plus.svg"
                            on:click={() => {
                            console.log(section);
                            section.images.push({
                                src: "",
                                caption: "",
                            });
                            dispatch("change", value);
                        }}
                            alt="Bild hinzufügen"
                    />
                </div>
                {#each section.images as image}
                    <div class="image-section-container">
                        <div>
                            <label class="form-field-label">Bild URL</label>

                            <input
                                    class="input-style"
                                    type="text"
                                    value={image.src}
                                    on:input={(val) => {
                                    image.src = val.target.value;
                                    dispatch("change", value);
                                }}
                            />
                            <label class="form-field-label"
                            >Bild Beschreibung</label
                            >
                            <input
                                    class="input-style"
                                    type="text"
                                    value={image.caption}
                                    on:input={(val) => {
                                    image.caption = val.target.value;
                                    dispatch("change", value);
                                }}
                            />
                        </div>
                        <img
                                src="/images/icons/minus.svg"
                                class="delete-button"
                                on:click={() => {
                                section.images = section.images.filter(
                                    (img) => img !== image
                                );

                                if (section.images.length == 0) {
                                    value = value.filter(
                                        (sec) => sec !== section
                                    );
                                }

                                dispatch("change", value);
                            }}
                                on:keypress={(e) => {}}
                                alt="Bild löschen"
                        />
                    </div>
                {/each}
            {/if}
            {#if index < (translatable ? value[editLocale] : value.de ?? value ?? []).length - 1}
                <div class="divider-h" style="margin: 16px 0;"/>
            {/if}
        {/each}

        {#if required && (!value || value.length == 0)}
            <label class="form-field-label error-label"
            >Dieses Feld ist erforderlich</label
            >
        {/if}

        <div
                style="display: flex; flex-direction: row; padding: 32px 16px; justify-content: space-between;"
        >
            <button
                    on:click={() => {
                    //console.log(value);
                    if (translatable) {
                        value[editLocale] = [
                            ...(value[editLocale] ?? []),
                            { type: "html", header: "", content: "" },
                        ];
                    } else {
                        value = [
                            ...(value ?? []),
                            { type: "html", header: "", content: "" },
                        ];
                    }
                    console.log(value);

                    dispatch("change", value);
                }}
            >
                Textabschnitt hinzufügen
            </button>

            <button
                    on:click={() => {
                    //console.log(value);
                    if (translatable) {
                        value[editLocale] = [
                            ...(value[editLocale] ?? []),
                            {
                                type: "images",
                                images: [{ src: "", caption: "" }],
                            },
                        ];
                    } else {
                        value = [
                            ...(value ?? []),
                            {
                                type: "images",
                                images: [{ src: "", caption: "" }],
                            },
                        ];
                    }
                    dispatch("change", value);
                }}
            >
                Bildabschnitt hinzufügen
            </button>
        </div>
    </div>
{/if}

<style>
    :global(.tox-notification) {
        display: none !important;
    }

    .error-label {
        color: red;
        font-size: 12px;
        margin-top: -4px;
    }

    .input-style {
        border: 1px solid var(--black-100);
        padding: 24px 20px;
        background: transparent;
        width: 526px;
    }

    .form-field-label {
        font-weight: bold;
    }

    .image-section-container {
        display: flex;
        flex-direction: row;
    }

    .delete-button {
        padding: 16px;
    }

    .section-descriptor {
        font-weight: bold;
        margin-top: 8px;
    }

    .section-title-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .selector {
        border: 1px solid var(--black-100);
        padding: 24px 20px;
        background: transparent;
        width: 100%;
        max-width: 528px;
    }

    .open-in-new {
        margin-left: 8px;
    }
</style>
